import React, { useState, useEffect, useContext } from "react";
import background from "./images/background.jpg";
import PrivateRoute from "./context/PrivateRoute";
import { AuthContext } from "./context/auth";
import { JWT } from "./constants/local-storage";
import { store } from "./context/store";
import { library } from "@fortawesome/fontawesome-svg-core";

import SystemLogin from "./pages/SystemLogin";
import LogOut from "./pages/LogOut";
import Home from "./pages/Home";
import Project from "./pages/Project";
import Building from "./pages/Building";
import Administration from "./pages/Administration";
import Floor from "./pages/floor/Floor";

import {
  faHome,
  faTimes,
  faArrowLeft,
  faArrowRight,
  faFileExport,
  faQuestion,
  faCalendarAlt,
  faClock,
  faUser,
  faCogs,
  faGear,
  faDownload,
  faCloudArrowUp,
  faTrash,
  faCameraRotate,
  faCheck,
  faTriangleExclamation,
  faStopwatch,
  faBell,
} from "@fortawesome/free-solid-svg-icons";

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

library.add(
  faHome,
  faTimes,
  faArrowLeft,
  faArrowRight,
  faFileExport,
  faQuestion,
  faCalendarAlt,
  faClock,
  faUser,
  faCogs,
  faGear,
  faDownload,
  faCloudArrowUp,
  faTrash,
  faCameraRotate,
  faCheck,
  faTriangleExclamation,
  faStopwatch,
  faBell
);

export default function App() {
  const existingTokens = localStorage.getItem(JWT) || "null";
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const [authTokens, setAuthTokens] = useState(existingTokens);

  useEffect(() => {
    if (authTokens && authTokens !== "null" && notExpired(authTokens)) {
      // still valid
    } else {
      localStorage.setItem(JWT, "null");
      setAuthTokens(null);
    }
  }, [authTokens]);

  const notExpired = (token) => {
    try {
      const exp = JSON.parse(atob(token.split(".")[1]))["exp"];
      const tokenExpire = 1000 * exp;
      return Date.now() < tokenExpire;
    } catch (e) {
      return false;
    }
  };

  const setTokens = (data) => {
    localStorage.setItem(JWT, data);
    setAuthTokens(data);
  };

  const thisContainer = {
    display: "flex",
    width: "100%",
    height: "100%",
    backgroundSize: "100% 100%",
    backgroundImage: "url(" + background + ")",
    flexDirection: "column",
  };

  return (
    <div style={thisContainer} id="app-container">
      <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens }}>
        <Router style={{ width: "100%", height: "100%" }}>
          <Switch>
            {/* Default route goes straight to Home */}
            <Route exact path="/" component={Home} />

            {/* Public routes (offline) */}
            <Route path="/project" component={Project} />
            <Route path="/building" component={Building} />
            <Route path="/floor" component={Floor} />

            {/* Admin route requires login */}
            <PrivateRoute path="/administration" component={Administration} />

            {/* Login/logout routes */}
            <Route path="/login" component={SystemLogin} />
            <Route path="/logout" component={LogOut} />
          </Switch>
        </Router>
      </AuthContext.Provider>
    </div>
  );
}
